import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'
import AssaysModalBasicForm from '@/modules/configurationModule/detail/automation/assays/components/assays-modal-basic-form/configuration-automation-assays-modal-basic-form.vue'
import AssaysModalRelationships from '@/modules/configurationModule/detail/automation/assays/components/assays-modal-relationships/configuration-automation-assays-modal-relationships.vue'
import { BModal } from 'bootstrap-vue'
import { ConfigurationAutomationAssaysModalState, ConfigurationAutomationAssaysModalTabIndex, initialConfigurationAutomationAssaysModalState } from '@/modules/configurationModule/detail/automation/assays/components/assays-modal/configuration-automation-assays-modal.model'
import { ConfigurationOntologyForAutomaticAssayResponse } from '@/modules/configurationModule/detail/automation/assays/services/configuration-ontology-for-automatic-assay/configuration-ontology-for-automatic-assay.dto'
import { Nullable } from '@/shared/types/app.types'

@Component({
    components: {
        AssaysModalBasicForm,
        AssaysModalRelationships
    }
})
export default class ConfigurationAutomationAssaysModal extends Vue {
    @Ref() readonly automationAssaysModal!: BModal

    @Prop(String) readonly actionTitle!: string

    @Emit()
    create(): void {}

    state: ConfigurationAutomationAssaysModalState
    constructor() {
        super()
        this.state = initialConfigurationAutomationAssaysModalState()
    }

    get isAssaysTabDisabled(): boolean {
        return !this.state.ontologyForAutomaticAssay?.id && !this.state.showAssaysTab
    }

    get assayOntologyId(): Nullable<number> {
        return this.state.ontologyForAutomaticAssay?.id
    }

    async show(ontologyForAutomaticAssay?: Nullable<ConfigurationOntologyForAutomaticAssayResponse>): Promise<void> {
        await this.$validator.reset()

        this.state = initialConfigurationAutomationAssaysModalState()

        if (ontologyForAutomaticAssay) {
            this.state.ontologyForAutomaticAssay = ontologyForAutomaticAssay
        }

        this.automationAssaysModal.show()
    }

    hide(): void {
        this.automationAssaysModal.hide()
    }

    onCreateOntologyForAutomaticAssay(createdAssay: Nullable<Partial<ConfigurationOntologyForAutomaticAssayResponse>>) {
        this.state.showAssaysTab = true
        this.state.ontologyForAutomaticAssay = createdAssay
        this.create() // emits an event
        // wait for the DOM update (when Assays tab is active)
        this.$nextTick(() => (this.state.activeTabIndex = ConfigurationAutomationAssaysModalTabIndex.ASSAYS))
    }
}
